import { Environment } from './environment.interface';

export const environment: Environment = {
  isProduction: false,
  isLocal: false,
  baseApiUrl: 'https://api-qa.imagise.cloud/',
  siteUrl: 'https://www.imagise.app',
  googleAnalyticsId: null,
  localImageProcessingEnabled: false,
};
